<div *ngIf="user" class="user-general-information">
    <div hidden class="edit-profile-picture">
        <img
            class="user-profile-image"
            src="https://a57.foxnews.com/media2.foxnews.com/BrightCove/694940094001/2018/06/21/931/524/694940094001_5800293009001_5800284148001-vs.jpg?ve=1&tl=1"
            alt="profile-image"
        />
        <div hidden class="image-black-circle" (click)="updateProfilePicture()">
            <div class="edit-image-container">
                <mat-icon svgIcon="aumico-users-icon-edit-image"></mat-icon>
            </div>
        </div>
    </div>
    <div [formGroup]="profileFormGroup" class="edit-profile-form form-container">
        <div class="form-row header-row">
            <span class="aum-typo-paragraph-l">
                {{ 'aumico_users_edit_user_general_information_edit_your_profile' | i18next }}
            </span>
        </div>

        <div class="form-row">
            <aum-select
                placeholder="{{ 'aumico_users_edit_user_general_information_select_salutation' | i18next }}"
                floatLabel="always"
                [options]="salutations"
                [aumFormControl]="profileFormGroup.controls['salutation']"
            >
                <aum-form-field-label>{{
                    'aumico_users_edit_user_general_information_salutation' | i18next
                }}</aum-form-field-label>
                <aum-form-error>{{ 'aumico_users_aumico_form_error' | i18next }}</aum-form-error>
            </aum-select>
        </div>
        <div class="form-row">
            <aum-input
                placeholder="{{ 'aumico_users_edit_user_general_information_enter_name' | i18next }}"
                [aumFormControl]="profileFormGroup.controls['name']"
            >
                <aum-form-field-label>{{
                    'aumico_users_edit_user_general_information_name' | i18next
                }}</aum-form-field-label>
                <aum-form-error *ngIf="profileFormGroup.controls['name'].hasError('required')">
                    {{ 'aumico_users_edit_user_general_information_name_required' | i18next }}
                </aum-form-error>
            </aum-input>
            <aum-input
                class="user-lastname"
                placeholder="{{ 'aumico_users_edit_user_general_information_enter_surname' | i18next }}"
                [aumFormControl]="profileFormGroup.controls['surname']"
            >
                <aum-form-field-label>{{
                    'aumico_users_edit_user_general_information_surname' | i18next
                }}</aum-form-field-label>
                <aum-form-error *ngIf="profileFormGroup.controls['surname'].hasError('required')">
                    {{ 'aumico_users_edit_user_general_information_surname_required' | i18next }}
                </aum-form-error>
            </aum-input>
        </div>
        <div class="form-row">
            <aum-input
                placeholder="{{ 'aumico_users_edit_user_general_information_enter_email_address' | i18next }}"
                [aumFormControl]="profileFormGroup.controls['email']"
            >
                <aum-form-field-label>{{
                    'aumico_users_edit_user_general_information_email_address' | i18next
                }}</aum-form-field-label>
            </aum-input>
        </div>

        <div class="form-row">
            <aum-input
                placeholder="{{ 'aumico_users_edit_user_general_information_enter_phone_number' | i18next }}"
                [aumFormControl]="profileFormGroup.controls['phone']"
            >
                <aum-form-field-label>{{
                    'aumico_users_edit_user_general_information_phone' | i18next
                }}</aum-form-field-label>
                <aum-form-error *ngIf="profileFormGroup.controls['phone'].hasError('phoneNumberInvalid')">
                    {{ 'aumico_users_edit_user_general_information_phone_invalid' | i18next }}
                </aum-form-error>
            </aum-input>
        </div>
        <div class="border-top-separator"></div>

        <div class="edit-profile-form-separator">
            <span class="aum-typo-paragraph-l">
                {{ 'aumico_users_edit_user_general_information_settings' | i18next }}
            </span>
        </div>
        <div class="form-row">
            <aum-select
                placeholder="{{ 'aumico_users_edit_user_general_information_choose_language' | i18next }}"
                floatLabel="always"
                [options]="languages"
                [aumFormControl]="profileFormGroup.controls['language']"
            >
                <aum-form-field-label>{{
                    'aumico_users_edit_user_general_information_langugage' | i18next
                }}</aum-form-field-label>
                <aum-form-error>{{ 'aumico_users_aumico_form_error' | i18next }}</aum-form-error>
            </aum-select>
        </div>
        <div class="form-row">
            <aum-select [aumFormControl]="profileFormGroup.controls['country']" [options]="countries">
                <aum-form-field-label>
                    {{ 'aumico_admin_countries_label' | i18next }}
                </aum-form-field-label>
            </aum-select>
        </div>
    </div>
</div>
